import React, { useEffect, useRef, useState } from 'react';

import ContractTopbar from './ContractTopbar';

import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import EventBus from "../../common/EventBus";
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import ResourceService from '../../service/ResourceService';
import { ContractDetail } from './ContractDetail';


export const Contract = (props) => {
    const { t } = useTranslation();
    const toast = useRef(null);
    const navigate = useNavigate();


    const [displayLoadingDialog, setDisplayLoadingDialog] = useState(false);

    const [contract, setContract] = useState("");
    let { resourceCode } = useParams();


    useEffect(() => {
        loadContract();
    }, []);



    const loadContract = async () => {
        setDisplayLoadingDialog(true);
        setContract();
        ResourceService.inquireResource(resourceCode?resourceCode:props.resourceCode).then(
            (response) => {
                console.log("inquireResource", response)
                console.log("inquireResource", response?.data?.data?.dataList)
                if (response?.data?.data?.dataList?.length > 0) {
                    console.log("set inquireResource", response?.data?.data?.dataList)
                    setContract(response?.data?.data?.dataList[0].value);
                }
                setDisplayLoadingDialog(false);
            },
            (error) => {
                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {

                    console.log("inquireResource logout******")
                    EventBus.dispatch("logout", props);
                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );

    }




    return (
        <div className='root-profile' style={{ paddingBottom: 70 }}>

            <div className='surface-profile-header'>
                <Toast ref={toast} />
                <Dialog visible={displayLoadingDialog} breakpoints={{ '960px': '75vw' }} closable={false} className='p-dialog-load' header={<></>} >
                    <div>
                        <img src="/assets/layout/images/page-loader.gif" alt='Loading...' width="125px" height="125px">
                        </img>
                    </div>
                </Dialog>

                <ContractTopbar></ContractTopbar>

                <ContractDetail></ContractDetail>
            </div >
        </div >
    );
};

